export default "__VITE_ASSET__DbEjFvhg__"